import { format } from 'date-fns-tz';
import { utcToSite } from '../../../../../datetimeUtils';

export function triangulateVectors({ M1, M2, M3 }) {
  const [X, Y] = [
    (0 + M2 * Math.cos((7 * Math.PI) / 6) + M3 * Math.cos((11 * Math.PI) / 6)).toFixed(2),
    (M1 + M2 * Math.sin((7 * Math.PI) / 6) + M3 * Math.sin((11 * Math.PI) / 6)).toFixed(2),
  ];

  return [-X, -Y];
}

export function getAxisCoordinates({ axisValues }) {
  let X = 0;
  let Y = 0;

  for (const [index, value] of axisValues.entries()) {
    X += value * Math.cos((((12 / axisValues.length) * index + 3) * Math.PI) / 6);
    Y += value * Math.sin((((12 / axisValues.length) * index + 3) * Math.PI) / 6);
  }

  return [-X, -Y];
}

export function getPlotCoordinates({ dataPoint, configuration, series, inputMode }) {
  if (inputMode === 'cartesian') {
    const X = dataPoint[configuration.plot?.X || series[0]?.id] || 0;
    const Y = dataPoint[configuration.plot?.Y || series[1]?.id] || 0;
    return [X, Y];
  }
  return triangulateVectors({
    M1: dataPoint[configuration.plot?.L1 || series[0]?.id] || 0,
    M2: dataPoint[configuration.plot?.L2 || series[1]?.id] || 0,
    M3: dataPoint[configuration.plot?.L3 || series[2]?.id] || 0,
  });
}

// Cartesian mode plots 2 signals (X/Y); vectors mode plots 3 (L1/L2/L3), unlike the type's generic minSignal/maxSignal range
export function getRequiredStarSignalCount(inputMode) {
  return inputMode === 'cartesian' ? 2 : 3;
}

export function getStarPlotSignalIds({ configuration = {}, variables = [] }) {
  const { inputMode, plot = {} } = configuration;
  const axes = inputMode === 'cartesian' ? ['X', 'Y'] : ['L1', 'L2', 'L3'];

  return axes
    .map((axis, index) => {
      if (plot[axis] !== undefined) return plot[axis];
      const variable = variables[index];
      return variable ? `${variable.id}.${variable.aggregate}` : undefined;
    })
    .filter(Boolean);
}

export function getStarPlotVariables({ configuration, variables = [] }) {
  return getStarPlotSignalIds({ configuration, variables })
    .map((signal) => {
      const [id, aggregate] = signal.split('.');
      return (
        variables.find((variable) => variable.id === id && variable.aggregate === aggregate) ||
        variables.find((variable) => variable.id === id)
      );
    })
    .filter(Boolean);
}

export const tooltipLabelFormatter = (time, timezone) => {
  const dateFormat = 'yyyy-MM-dd, HH:mm:ss';
  return format(utcToSite(time, timezone), dateFormat, { timeZone: timezone });
};
